import constants from "constants";

const {
  SAVE_STUDYGROUPS,
  SET_STUDYGROUP,
  CLEAN_STUDYGROUP,
  SET_GROUP_MEMBERS,
  SET_GROUP_MATERIAL,
  SET_GROUP_MATERIAL_INFINITY,
  CLEAR_STUDY_GROUP_MATERIALS,
  UPDATE_GROUP_MATERIALS_AFTER_DELETE,
  SET_STUDY_GROUP_INVITES,
  SET_STUDY_GROUP_STATISTIC,
  SET_STUDY_GROUP_WEBINARS,
  SET_ADMIN_GROUP_MEMBERS,
  SET_GROUP_INVITES,
  DELETE_INVITE_SUCCESS,
  SET_COURSE_MATERIALS,
  SET_COURSE_MATERIAL,
  CLEAR_COURSE_MATERIALS,
  SAVE_STUDYGROUPS_INFINITE,
  CLEAR_STUDY_GROUPS,
  UPDATE_STUDY_GROUP_REQUEST,
} = constants;

const defaultValue = {
  studygroups: {
    values: [],
    page: 1,
    per_page: 5,
    count: 0,
    total_pages: 0,
    query: {},
  },
  studygroup: {},
  groupMembers: {
    values: [],
    page: 1,
    per_page: 5,
    count: 0,
    total_pages: 0,
    query: {},
  },
  groupInvites: {
    values: [],
    page: 1,
    per_page: 5,
    count: 0,
    total_pages: 0,
    query: {},
  },
  courseMaterials: {
    values: [],
    page: 1,
    per_page: 5,
    count: 0,
    total_pages: 0,
    query: {},
  },
  courseMaterial: {},
  members: {
    data: [],
  },
  materials: {
    data: [],
  },
  invites: {
    data: [],
  },
  statistic: {
    data: [],
  },
  webinars: {
    data: [],
  },
  tmp: {},
};

export const studygroups = (
  studygroups = defaultValue,
  { type, studygroup, members, payload, inviteId, courseMaterial, groupId }
) => {
  switch (type) {
    case CLEAR_STUDY_GROUPS:
      return {
        ...studygroups,
        studygroups: {
          values: [],
          page: 1,
          per_page: 5,
          count: 0,
          total_pages: 0,
          query: {},
        },
      };
    case SAVE_STUDYGROUPS:
      return {
        ...studygroups,
        studygroups: {
          values: payload.studygroups,
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          query: payload.query,
        },
      };
    case SAVE_STUDYGROUPS_INFINITE:
      return {
        ...studygroups,
        studygroups: {
          values: [...studygroups.studygroups.values, ...payload.studygroups],
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          query: payload.query,
        },
      };
    case SET_STUDYGROUP:
      return {
        ...studygroups,
        tmp: studygroup,
        studygroup,
      };
    case SET_ADMIN_GROUP_MEMBERS:
      return {
        ...studygroups,
        groupMembers: {
          ...studygroups.members,
          values: payload.members,
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          query: payload.query,
        },
      };
    case SET_GROUP_INVITES:
      return {
        ...studygroups,
        groupInvites: {
          ...studygroups.groupInvites,
          values: payload.invites,
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          query: payload.query,
        },
      };
    case DELETE_INVITE_SUCCESS: {
      const allInvites = [...studygroups.groupInvites.values];
      const inviteIndex = allInvites
        .map((invite) => invite.id)
        .indexOf(inviteId);
      allInvites.splice(inviteIndex, 1);

      return {
        ...studygroups,
        groupInvites: {
          ...studygroups.groupInvites,
          values: allInvites,
          count: studygroups.groupInvites.count - 1,
        },
      };
    }
    case SET_COURSE_MATERIALS:
      return {
        ...studygroups,
        courseMaterials: {
          ...studygroups.courseMaterials,
          values: payload.courseMaterials,
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          query: payload.query,
        },
      };
    case CLEAR_COURSE_MATERIALS:
      return {
        ...studygroups,
        courseMaterials: {
          values: [],
          page: 1,
          per_page: 5,
          count: 0,
          total_pages: 0,
          query: {},
        },
      };
    case SET_COURSE_MATERIAL:
      return {
        ...studygroups,
        courseMaterial,
      };
    case SET_GROUP_MEMBERS:
      return {
        ...studygroups,
        members: {
          count: payload.count,
          totalPages: payload.total_pages,
          data: payload.members,
        },
      };
    case SET_GROUP_MATERIAL:
      return {
        ...studygroups,
        materials: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: payload.group_materials,
        },
      };
    case SET_GROUP_MATERIAL_INFINITY:
      return {
        ...studygroups,
        materials: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: [...studygroups.materials.data, ...payload.group_materials],
        },
      };
    case UPDATE_GROUP_MATERIALS_AFTER_DELETE:
      return {
        ...studygroups,
        materials: {
          totalPages: payload.total_pages,
          count: studygroups.materials.count - 1,
          data: studygroups.materials.data.filter(({ id }) => payload !== id),
        },
      };
    case CLEAR_STUDY_GROUP_MATERIALS:
      return {
        ...studygroups,
        materials: {
          data: [],
        },
      };
    case SET_STUDY_GROUP_INVITES:
      return {
        ...studygroups,
        invites: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: payload.invites,
        },
      };
    case SET_STUDY_GROUP_STATISTIC:
      return {
        ...studygroups,
        statistic: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: payload.webinars,
        },
      };
    case SET_STUDY_GROUP_WEBINARS:
      return {
        ...studygroups,
        webinars: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: payload.webinars,
        },
      };
    case CLEAN_STUDYGROUP:
      return defaultValue;
    case UPDATE_STUDY_GROUP_REQUEST:
      return {
        ...studygroups,
        studygroups: {
          ...studygroups.studygroups,
          values: studygroups.studygroups.values.map((studygroup) =>
            studygroup.id === payload.groupId
              ? { ...studygroup, ...payload.data }
              : studygroup
          ),
        },
      };
    default:
      return { ...studygroups };
  }
};



// WEBPACK FOOTER //
// ./src/reducers/studygroups.js